/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import React, { ReactNode } from 'react'
import Text from '../../Text'
import colors from '@sportninja/common/constants/appColors'

interface OptionCardProps {
  id?: string
  icon: ReactNode
  title: string
  description: string
  isSelected: boolean
  onClick: () => void
}

const CardContainer = styled.div<{ isSelected: boolean }>`
  background: ${(props) =>
    props.isSelected ? colors.PRIMARY : colors.SECONDARY_400};
  border: 2px solid
    ${(props) => (props.isSelected ? colors.PRIMARY : colors.SECONDARY_300)};
  border-radius: 12px;
  padding: 24px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  flex: 1;
  min-height: 220px;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    border-color: ${(props) =>
      props.isSelected ? colors.PRIMARY : colors.PRIMARY_400};
  }
`

const IconContainer = styled.div<{ isSelected: boolean }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${(props) =>
    props.isSelected ? colors.SECONDARY_500 : colors.SECONDARY_300};
  display: flex;
  align-items: center;
  justify-content: center;
`

const TitleContainer = styled.div``

const DescriptionContainer = styled.div``

/**
 * Option card component for league type selection
 * Displays an icon, title, and description with selection state
 */
const OptionCard: React.FC<OptionCardProps> = ({
  icon,
  title,
  description,
  isSelected,
  onClick,
}) => {
  return (
    <CardContainer isSelected={isSelected} onClick={onClick}>
      <IconContainer isSelected={isSelected}>{icon}</IconContainer>
      <TitleContainer>
        <Text
          variant='heading5'
          weight='semiBold'
          color={isSelected ? colors.SECONDARY_500 : colors.NEUTRAL_0}
        >
          {title}
        </Text>
      </TitleContainer>

      <DescriptionContainer>
        <Text
          variant='paragraphSmall'
          weight='regular'
          color={isSelected ? colors.SECONDARY_500 : colors.NEUTRAL_100}
        >
          {description}
        </Text>
      </DescriptionContainer>
    </CardContainer>
  )
}

export default OptionCard
